import { LitElement, PropertyValues } from "lit";
import { adoptStyles } from 'lit';
import { sharedStylesheet, SetStylesInElement as SetRoutedStyles, ApplyStylesToDependant } from "../Styling/browsersetter";
import { DelegateEvent } from "./metanode";

export function BFactory<T extends BrowserObject<U>, U extends { id: number }>(ElementClass: new () => T, initialArguments: U): T {
    const element = new ElementClass();
    element.initialArguments = initialArguments;    
    (window as any).ood(element.initialArguments.id, element);    
    return element;
}


export class SElement extends LitElement {
    override  createRenderRoot() {
        const root = this.attachShadow({ mode: 'open' });
        root.adoptedStyleSheets = [sharedStylesheet!]; // Ensure the shared stylesheet is applied        
        return root;
    }
}



export class BOFragment extends SElement {
    readonly binded: BrowserObject<any>;
    constructor(binding: BrowserObject<any>) {
        super();
        this.binded = binding;
    }

    protected override updated(_changedProperties: PropertyValues): void {
        super.updated(_changedProperties);
        ApplyStylesToDependant(this.binded,this);
    }

    pushEvent(payload: any): void {
        this.binded.pushEvent(payload);
    }

}


export abstract class BrowserObject<T extends { id: number }> extends SElement {
    initialArguments!: T;
    pushEvent(payload: T): void {
        (window as any).jsE(this.id, payload);
    }
    
    protected override updated(_changedProperties: PropertyValues): void {
        super.updated(_changedProperties);
        SetRoutedStyles(this);
        //this.onUpdated.invoke(_changedProperties);
    }
    private _payloadTarget?: HTMLElement;
    get payloadTarget(): HTMLElement { return this._payloadTarget !== undefined ? this._payloadTarget : this; }
    set payloadTarget(value: HTMLElement) { this._payloadTarget = value; }   
}
